// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".over-delivery-part-dialog[data-v-68d397fa]  .el-dialog__body {\n  padding-bottom: 0;\n}\n.container .container--top[data-v-68d397fa] {\n  margin-bottom: 16px;\n}\n.container .container--bottom .control-buttons[data-v-68d397fa] {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
